/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({
  name: 'translate',
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  /**
   * Default constructor.
   *
   * @param $translate
   */
  constructor(private $translate : TranslationService) {}

  /**
   * Transform the passed in sting as a translated keyword.
   *
   * @param value Value passed into the pipe.
   * @param args Any additional arguments.
   */
  transform(value: any, ...args: any[]) : string {
    return this.$translate.translateInstant(value);
  }
}
